import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex justify-center" }
const _hoisted_2 = { class: "flex items-center border-b-2 py-2" }
const _hoisted_3 = { class: "text-sm font-semibold text-gray-700" }
const _hoisted_4 = { class: "text-sm text-gray-500" }
const _hoisted_5 = { class: "pt-2" }
const _hoisted_6 = {
  id: "etia",
  class: "flex justify-center",
  style: {"justify-content":"space-evenly","user-select":"none"}
}
const _hoisted_7 = { class: "flex flex-col items-center" }
const _hoisted_8 = {
  class: "mb-2 text-base basecolor",
  for: "ethnic-W"
}
const _hoisted_9 = { class: "flex flex-col space-y-2" }
const _hoisted_10 = { class: "flex items-center space-x-2" }
const _hoisted_11 = ["checked"]
const _hoisted_12 = { class: "flex items-center space-x-2" }
const _hoisted_13 = ["checked"]
const _hoisted_14 = { class: "flex items-center space-x-2" }
const _hoisted_15 = ["checked"]
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col items-center\"><label for=\"smoke\" class=\"text-base basecolor\">Fumatore</label><input id=\"smoke\" type=\"checkbox\" class=\"checkbox-custom\"></div><div class=\"flex flex-col items-center\"><label for=\"diab\" class=\"text-base basecolor\">Diabete</label><input id=\"diab\" type=\"checkbox\" class=\"checkbox-custom\"></div><div class=\"flex flex-col items-center\"><label for=\"sbp\" class=\"text-base basecolor\">Trattamento ipertensione</label><input id=\"sbp\" type=\"checkbox\" class=\"checkbox-custom\"></div>", 3)
const _hoisted_19 = { class: "mt-4 shadow-none h-16 w-full border border-black rounded-lg p-4 result" }
const _hoisted_20 = {
  role: "status",
  style: {"display":"inline-block","margin-left":"47%","margin-top":"5%"}
}
const _hoisted_21 = ["aria-hidden"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("path", {
  d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("path", {
  d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
  fill: "currentFill"
}, null, -1)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_26 = { style: {"padding-bottom":"5em"} }
const _hoisted_27 = { class: "tableWrapper" }
const _hoisted_28 = { class: "tableHeader" }
const _hoisted_29 = { class: "centrato" }
const _hoisted_30 = { class: "centrato" }

import CalculatorDescription from "../components/CalculatorDescription.vue";
import CalcoloScoresInput from "../components/CalcoloScoresInput.vue";
import BaseOutput from "../components/BaseOutput.vue";
import BaseButtons from "../components/BaseButtons.vue";

import { saveScore } from "../../../../../EshJSLib/services/scoreServices";
import { Score } from "@/../../EshJSLib/models/patient";

import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import { ref, reactive } from "vue";

import AlertModal from "@/components/AlertModal.vue";
import { Modal } from "flowbite-vue";

import '../calcolatriceMedica.css'


export default /*#__PURE__*/_defineComponent({
  __name: 'CardiovascolareScore',
  emits: ["cancel"],
  setup(__props, { emit }) {

const store = patientStore();
const { patient } = storeToRefs(store);

const mostraSalva = ref(false);
let puntegioTotale = ref();
let eta = ref(patient.value.paziente_eta);
let sesso = ref(patient.value.paziente_sesso);
let colesteroloTotale = ref();
let colesteroloHdl = ref();
let sistolica = ref();
let smoker = ref(0);
let isTreated = ref(0);
let diabetes = ref(0);
let cardiovascolareScore = {} as Score;


// Appendix 4, Table A, of https://pmc.ncbi.nlm.nih.gov/articles/PMC4700825/?utm_source
// N/A vals are not included into the calculator, then N/A vals = "0"
// "Other" ethnics are included as "White"
const coefficients = {
  "white_women": {
    ln_age: -29.799,
    ln_age_sq: 4.884,
    ln_total_chol: 13.540,
    ln_age_ln_total_chol: -3.114,
    ln_hdl: -13.578,
    ln_age_ln_hdl: 3.149,
    log_trt_sbp: 2.019,
    log_age_treated_sbp: 0,
    log_untreated_sbp: 1.957,
    log_age_untreated_sbp: 0,
    current_smoker: 7.574,
    log_age_smoker: -1.665,
    diabetes: 0.661,
    mean_coef_value: -29.18,
    baseline_survival: 0.9665
  },

  "aa_women": {  // African American Women
    ln_age: 17.114,
    ln_age_sq: 0,
    ln_total_chol: 0.940,
    ln_age_ln_total_chol: 0,
    ln_hdl: -18.920,
    ln_age_ln_hdl: 4.475,
    log_trt_sbp: 29.291,
    log_age_treated_sbp: -6.432,
    log_untreated_sbp: 27.820,
    log_age_untreated_sbp: -6.087,
    current_smoker: 0.691,
    log_age_smoker: 0,
    diabetes: 0.874,
    mean_coef_value: 86.61,
    baseline_survival: 0.9533
  },
 
  "white_men": {
    ln_age: 12.344,
    ln_age_sq: 0,
    ln_total_chol: 11.853,
    ln_age_ln_total_chol: -2.664,
    ln_hdl: -7.990,
    ln_age_ln_hdl: 1.769,
    log_trt_sbp: 1.797,
    log_age_treated_sbp: 0,
    log_untreated_sbp: 1.764,
    log_age_untreated_sbp: 0,
    current_smoker: 7.837,
    log_age_smoker: -1.795,
    diabetes: 0.658,
    mean_coef_value: 61.18,
    baseline_survival: 0.9144
  },

  "aa_men": {  // African American Men
    ln_age: 2.469,
    ln_age_sq: 0,
    ln_total_chol: 0.302,
    ln_age_ln_total_chol: 0,
    ln_hdl: -0.307,
    ln_age_ln_hdl: 0,
    log_trt_sbp: 1.916,
    log_age_treated_sbp: 0,
    log_untreated_sbp: 1.809,
    log_age_untreated_sbp: 0,
    current_smoker: 0.549,
    log_age_smoker: 0,
    diabetes: 0.645,
    mean_coef_value: 19.54,
    baseline_survival: 0.8954
  }
};

const isShowModal = reactive({
  alert: false,
});



let loading = ref(false);
let alertStatus = ref('');

function saveCardiovascolareScore() {
  loading.value = true;
  try {
  cardiovascolareScore.id_paziente = patient.value!.id_paziente;
  cardiovascolareScore.nome_score = "cardiovascolare-score";
  cardiovascolareScore.valore_score = puntegioTotale.value;
  const datartn = saveScore(cardiovascolareScore).then((x) => {
      alertStatus.value = 'success';
      isShowModal.alert = true; 
      loading.value = false;
      puntegioTotale.value = 0;
      for (const item of store.cardiovascolareScoreList) {
        item.isSelected = 0; 
      }
      store.fetchCardiovascolareRelatedData();
    });
  // cardiovascolareScore = {} as Score;
  } catch{((error) => {
      alertStatus.value = 'fail';
      isShowModal.alert = true; 
      loading.value = false;
      store.fetchCardiovascolareRelatedData();
      emit("cancel");
    });
  }
}

let ethnic = ref("W");

const ethnicMap = {
  W: 'white',
  AA: 'aa',
  O: 'white'    // "Other" considerato come "white"
};

const genderMap = {
  female: 'women',
  male: 'men',
};

// Checks for patients' ethnic and sex
function checker() {
  if (ethnicMap[ethnic.value] && genderMap[sesso.value]) {
    console.log("ethnicMap[ethnic.value]:", ethnicMap[ethnic.value]);
    console.log("genderMap[sesso.value]:", genderMap[sesso.value]);
    console.log('Possibile chiave: ', `${ethnicMap[ethnic.value]}_${genderMap[sesso.value]}`.toLowerCase());
    return `${ethnicMap[ethnic.value]}_${genderMap[sesso.value]}`.toLowerCase();
  } else {
    console.log("Parametri non gestiti!");
    return null;
  }
}

function logger(val) {
   if (val <= 0 || isNaN(val)) {
    console.error("Valore non valido per log:", val);
    return NaN;
  } else {
    let res = Math.log(Number(val));
    return res;
  }
}

// Gestisce in automatico il valore della pressione sistolica se trattata o meno
function calcHypertension(v: (typeof coefficients)[keyof typeof coefficients]) {
  console.log("trattamento ", isTreated.value)
  const sbpCoeff = (isTreated.value === 1) ? v.log_trt_sbp : v.log_untreated_sbp;
  const ageSbpCoeff = (isTreated.value === 1) ? v.log_age_treated_sbp : v.log_age_untreated_sbp;

  const result = [
    sbpCoeff * logger(sistolica.value) +
    ageSbpCoeff * logger(eta.value) * logger(sistolica.value)
  ];
  console.log("sbpCoeff", sbpCoeff, v.log_trt_sbp, v.log_untreated_sbp, logger(sistolica.value))
  console.log("ageSbpCoeff", ageSbpCoeff)

  return Number(result).toFixed(2);
}

function calculator() {
  const coeffKey = checker();

  if (!coeffKey) {
    puntegioTotale.value = "Compila e/o seleziona tutti i campi!";
    mostraSalva.value = false;
    return;
  }

  const valCoeff = coefficients[coeffKey]

  let valors = {
    ager: (valCoeff.ln_age * logger(eta.value)).toFixed(2),
    agerSq: (valCoeff.ln_age_sq * Math.pow(logger(eta.value), 2)).toFixed(2),
    cholTot:  (valCoeff.ln_total_chol * logger(colesteroloTotale.value)).toFixed(2),
    cholTotAge: (valCoeff.ln_age_ln_total_chol * (logger(eta.value) * logger(colesteroloTotale.value))).toFixed(2),
    cholHDL: (valCoeff.ln_hdl * logger(colesteroloHdl.value)).toFixed(2),
    cholHDLAge: (valCoeff.ln_age_ln_hdl * (logger(eta.value) * logger(colesteroloHdl.value))).toFixed(2),
    smo: (valCoeff.current_smoker * smoker.value).toFixed(2),
    smoAge: (valCoeff.log_age_smoker * (logger(eta.value) * smoker.value)).toFixed(2),
    diab: (valCoeff.diabetes * diabetes.value).toFixed(2),
    blood: (calcHypertension(valCoeff)),
  }

  Object.entries(valors).forEach(([key, value]) => {
    console.log(`${key}: ${value}`);
  });

  let sum = (Object.values(valors).reduce((acc, val) => acc + parseFloat(val), 0));
  console.log("sum", sum);

  // Il valore esce in percentuale
  puntegioTotale.value = ((1 - Math.pow(valCoeff.baseline_survival, Math.exp(sum - valCoeff.mean_coef_value))) * 100).toFixed(2);

  if (isNaN(puntegioTotale.value)) {
    puntegioTotale.value = "Inserire dei valori validi!";
    // NON MOSTRA IL BOTTONE
    mostraSalva.value = false;
  } else {
    // MOSTRA IL BOTTONE
    console.log("ELSE", puntegioTotale.value)
    mostraSalva.value = true;
  }
}

function changeEthnic(event: Event) {
  const target = event.target as HTMLInputElement;
  ethnic.value = target.value;
}

function changer(event: Event, val) {
  const target = event.target as HTMLInputElement;

  switch(val) {
    case 'smoke': smoker.value = target.checked ? 1 : 0;
    break;

    case 'diab': diabetes.value = target.checked ? 1 : 0;
    break;

    case 'blood': isTreated.value = target.checked ? 1 : 0;
    break;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(CalculatorDescription, {
        calculatorDescription: _ctx.$t('cardiovascolareDescription')
      }, null, 8, ["calculatorDescription"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).cardiovascolareScoreList, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "w-60 bg-white border-b-1",
          key: item.id
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_3, _toDisplayString(item.title), 1),
              _createElementVNode("p", _hoisted_4, _toDisplayString(item.description), 1)
            ])
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(CalcoloScoresInput, {
          label: _ctx.$t('Eta'),
          type: "number",
          modelValue: _unref(eta),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(eta) ? (eta).value = $event : eta = $event)),
          unit: _ctx.$t('Anni'),
          disabled: ""
        }, null, 8, ["label", "modelValue", "unit"]),
        _createVNode(CalcoloScoresInput, {
          label: _ctx.$t('Colesterolo totale'),
          type: "number",
          placeholder: "Norm: 150-200",
          modelValue: _unref(colesteroloTotale),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(colesteroloTotale) ? (colesteroloTotale).value = $event : colesteroloTotale = $event)),
          unit: "mq/dL"
        }, null, 8, ["label", "modelValue"]),
        _createVNode(CalcoloScoresInput, {
          label: _ctx.$t('Colesterolo HDL'),
          type: "number",
          placeholder: "Norm: 0-60",
          modelValue: _unref(colesteroloHdl),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(colesteroloHdl) ? (colesteroloHdl).value = $event : colesteroloHdl = $event)),
          unit: "mg/dL"
        }, null, 8, ["label", "modelValue"]),
        _createVNode(CalcoloScoresInput, {
          label: _ctx.$t('Pressione sistolica'),
          type: "number",
          placeholder: "Norm: 100-120",
          modelValue: _unref(sistolica),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(sistolica) ? (sistolica).value = $event : sistolica = $event)),
          unit: "mm/Hg"
        }, null, 8, ["label", "modelValue"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('Etnia')), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, [
                _createElementVNode("input", {
                  type: "radio",
                  id: "ethnic-W",
                  name: "ethnic",
                  value: "W",
                  checked: _unref(ethnic) === 'W',
                  onChange: changeEthnic
                }, null, 40, _hoisted_11),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('Caucasica')), 1)
              ]),
              _createElementVNode("label", _hoisted_12, [
                _createElementVNode("input", {
                  type: "radio",
                  id: "ethnic-AA",
                  name: "ethnic",
                  value: "AA",
                  checked: _unref(ethnic) === 'AA',
                  onChange: changeEthnic
                }, null, 40, _hoisted_13),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('Afro-Americana')), 1)
              ]),
              _createElementVNode("label", _hoisted_14, [
                _createElementVNode("input", {
                  type: "radio",
                  id: "ethnic-O",
                  name: "ethnic",
                  value: "O",
                  checked: _unref(ethnic) === 'O',
                  onChange: changeEthnic
                }, null, 40, _hoisted_15),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('Altro')), 1)
              ])
            ])
          ]),
          _hoisted_16
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(BaseOutput, {
          classType: "result",
          label: _ctx.$t('cardioScore'),
          key: "number",
          result: _unref(puntegioTotale),
          unit: "%"
        }, null, 8, ["label", "result"]),
        _createVNode(BaseButtons, {
          hiddenCancellaButton: "",
          onCalculate: calculator,
          hiddenSalvaButton: !mostraSalva.value,
          onSaveResult: saveCardiovascolareScore,
          class: "mt-2 mb-2 pt-2"
        }, null, 8, ["hiddenSalvaButton"]),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("div", _hoisted_20, [
            (_openBlock(), _createElementBlock("svg", {
              "aria-hidden": !_unref(loading),
              class: "w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600",
              viewBox: "0 0 100 101",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, _hoisted_24, 8, _hoisted_21)),
            _hoisted_25
          ], 512), [
            [_vShow, _unref(loading)]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("table", _hoisted_27, [
          _createElementVNode("tr", _hoisted_28, [
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("tableData1")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("cha2ds2Score1")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("cha2ds2Score2")), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).cardiovascolareScores, (result) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: result.id
            }, [
              _createElementVNode("td", _hoisted_29, _toDisplayString(result.created_at), 1),
              _createElementVNode("td", _hoisted_30, _toDisplayString(result.valore_score), 1)
            ]))
          }), 128))
        ])
      ]),
      (isShowModal.alert)
        ? (_openBlock(), _createBlock(_unref(Modal), {
            key: 0,
            onClose: _cache[5] || (_cache[5] = ($event: any) => {isShowModal.alert = false; _ctx.$emit('cancel')})
          }, {
            body: _withCtx(() => [
              _createVNode(AlertModal, {
                status: _unref(alertStatus),
                onCloseAlert: _cache[4] || (_cache[4] = ($event: any) => {isShowModal.alert = false; _ctx.$emit('cancel')})
              }, null, 8, ["status"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})